import { render, staticRenderFns } from "./ManageTags.vue?vue&type=template&id=09a8eedc&scoped=true&"
import script from "./ManageTags.vue?vue&type=script&lang=ts&"
export * from "./ManageTags.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTags.vue?vue&type=style&index=0&id=09a8eedc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8eedc",
  null
  
)

export default component.exports